import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import TopBar from 'elements/TopBar/TopBar';
import { ProjectConfig } from 'Global';
import { getHsfLabel, hsfCelebrationDate } from 'utils/hsfSantoral';
import './HsfSantoral.css';

export default function HsfSantoralList(props: any) {
  const langId = localStorage.getItem('lang_id') || '1';
  const [entries, setEntries] = useState<any[]>([]);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setFailed(false);
    props.setLoading(true);
    axios.get(ProjectConfig.api_url, {
      params: { request: 'hsf_santoral_list', lang_id: langId },
      timeout: 15000, signal: controller.signal,
    }).then(response => {
      if (!response.data.available || !Array.isArray(response.data.list)) throw new Error('HSF catalog unavailable');
      if (active) setEntries(response.data.list);
    }).catch(() => { if (active) setFailed(true); })
      .finally(() => { if (active) props.setLoading(false); });
    return () => { active = false; controller.abort(); };
  }, [langId, attempt, props.setLoading]);

  const card = (entry: any) => (
    <div className="CardList" key={entry.id}>
      <Link className="icon" to={`/santoral/hijos-sagrada-familia/${entry.id}`} onClick={() => props.setLoading(true)}>
        <span className="CardListTitle">{entry.name}</span>
        {hsfCelebrationDate(entry) && <small style={{ display: 'block', marginTop: 6 }}>{hsfCelebrationDate(entry)}</small>}
      </Link>
    </div>
  );
  return (
    <div id="HsfSantoral" className="module_container">
      <div className="module_topBar"><TopBar title={getHsfLabel('title')} /></div>
      <div className="module_content">
        <p>{getHsfLabel('summary')}</p>
        {failed ? <div className="CardContents"><p role="alert">{getHsfLabel('load_error')}</p><Button onClick={() => setAttempt(value => value + 1)}>{getHsfLabel('retry')}</Button></div> : <>
          <div className="flex_column hsf-santoral-cards">{entries.filter(entry => !entry.group_id).map(card)}</div>
          {entries.some(entry => entry.group_id) && <h2>{getHsfLabel('martyrs')}</h2>}
          <div className="flex_column hsf-santoral-cards">{entries.filter(entry => entry.group_id).map(card)}</div>
        </>}
      </div>
    </div>
  );
}
